import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ReportDetailPageRoutingModule } from "./report-detail-routing.module";
import { ReportDetailPage } from "./report-detail.page";
import { TranslateModule } from "@ngx-translate/core";
import { PopoverModule } from "src/app/components/popover/popover.module";
import { ReportKpiComponentModule } from "src/app/components/report-kpi/report-kpi.module";
import { ReportActionButtonComponentModule } from "src/app/components/report-action-button/report-action-button.module";
import { IsRelatedToReportModule } from "src/app/pipes/is-related-to-report/is-related-to-report.module";
import { ToDataDefinitionModule } from "src/app/pipes/to-data-definition/to-data-definition.module";
import { ParseReportValueModule } from "src/app/pipes/parse-report-value/parse-report-value.module";
import { ParseReportEmojiModule } from "src/app/pipes/parse-report-emoji/parse-report-value.module";
import { LogoModule } from "src/app/components/logo/logo.module";
import { Printer } from "@awesome-cordova-plugins/printer/ngx";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportDetailPageRoutingModule,
    TranslateModule,
    PopoverModule,
    ReportKpiComponentModule,
    ReportActionButtonComponentModule,
    IsRelatedToReportModule,
    ToDataDefinitionModule,
    ParseReportValueModule,
    ParseReportEmojiModule,
    LogoModule,
  ],
  providers: [Printer],
  declarations: [ReportDetailPage],
})
export class ReportDetailPageModule {}
